import { useMemo, createContext, useContext, useEffect } from 'react';
import { defaultReportType } from './constants/reports'
import _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { changeReportType } from 'actions/storyboardReports';
const ReportContext = createContext({ reportType: defaultReportType })

export const ReportsProvider = ({ children }) => {
  const dispatch = useDispatch();
  const reportType = useSelector(state => _.get(state, 'storyboards.storyboard.reports.reportType', defaultReportType));
  const value = useMemo(() => ({ reportType }), [reportType])
  
  useEffect(() => {
    return () => dispatch(changeReportType(defaultReportType))
  }, [dispatch])

  return (
    <ReportContext.Provider value={value}>
      {children}
    </ReportContext.Provider>
  )
}

export const useReportType = () => {
  const context = useContext(ReportContext);
  if (!context) {
    throw new Error("useReport must be used within a ReportsProvider");
  }
  return context;
};
